import React from 'react'
import Footer from '../../../Components/Footer/Footer'
import Navigation from '../../../Components/Navigation/Navigation'
import Hero from './Sections/Hero/Hero'
import Subservices from './Sections/Subservices/Subservices'
import AppComparison from './Sections/AppComparison/AppComparison'
import CaseStudies from "../../Home/Components/CaseStudies";
import ProcessSection from './Sections/ProcessSection/ProcessSection'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import mobileAppImage from '../../../assets/images/mobile_app.png'
import Industries from './Sections/Industries/Industries'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'

const MobileApp = () => {

    const subservicesTitles ={
        header: "We are your trusted m-commerce partner for driving outstanding solutions.",
        subservices: [
            {
            iconFileName: "crossplateformIcon.svg",
            title: "Cross-Platform App Development",
            subtitle: ""
        },
        {
            iconFileName: "webdevelopment.svg",
            title: "Web & Backend Development",
            subtitle: ""
        },
        {
            iconFileName: "customeecomarce.svg",
            title: "Custom Ecommerce Solutions",
            subtitle: ""
        },
        {
            iconFileName: "uiuxdesign.svg",
            title: "UI/UX Designing and Development",
            subtitle: ""
        },
        {
            iconFileName: "mobileecomarce.svg",
            title: "Mobile eCommerce App Development",
            subtitle: ""
        },
        {
            iconFileName: "arai.svg",
            title: "AR & AI Powered Apps",
            subtitle: ""
        },
        {
            iconFileName: "saas.svg",
            title: "Saas-based App Development",
            subtitle: ""
        },
        {
            iconFileName: "healthcare.svg",
            title: "Healthcare & HRMS App Development",
            subtitle: ""
        }
        ]
    }

    const homeContent = {
        title: "Build Future-Ready Mobile Apps for Southeast Asia's Digital Market",
        description: "Leverage Koolmind’s 8+ years of expertise to launch mobile apps that are secure, scalable, and customized for your region! Headquartered in Singapore, Malaysia, Thailand & India.",
        image: mobileAppImage,
        breadcrumb: "Mobile App",
    }

    const compareHeader = {
        title: "Difference between Hybrid Apps & Native Apps",
        description: "Find out which app model performs better, gives greater collaboration, and offers access to advanced mobile capabilities!"
    }

    const diff1 = {
        title: "Hybrid mobile app development",
        features: [
            { text: "Accelerated market release and low cost" },
            { text: "Reusable code for multiple platforms" },
            { text: "Easier to maintain" },
            { text: "Basic native features" },
            { text: "Performance lags with heavy graphics" },
            { text: "Ideal for MVP" },
            { text: "Cost-effective and time efficient" },
            { text: "Not suitable for advanced UI" },
            { text: "UI/UX restrictions" },
            { text: "Hosted by Google/Apple via webview engines" }
        ]
    }

    const diff2 = {
        title: "Native app development",
        features: [
            { text: "Best suited for specific platforms" },
            { text: "Perfectly works on iOS, Android, etc." },
            { text: "Rich user experience" },
            { text: "Enhanced performance" },
            { text: "Secure and scalable" },
            { text: "Fewer bugs & crashes" },
            { text: "Faster access to inbuilt device features" },
            { text: "Code is specific to the platform" },
            { text: "Custom feature built for the required device" },
            { text: "Works with minimum network latency" }
        ]
    }
    
    const processSection = {
        title: "Mobile App Development",
        description: "As a top mobile app development company in Asia, Koolmind is skilled in the best development life cycle. The goal? We simplify everything for you. Our 6-step approach ensures a smooth, fast, and cost-efficient rollout of tailored solutions.",
        steps: [
            {
                title: "Problem analysis",
                description: "We conduct an in-depth review of your business needs and analyze the challenges.",
                icon: "problem-analysis.svg"
            },
            {
                title: "Solution Structure",
                description: "We brainstorm unique solutions and outline a robust strategy for implementation.",
                icon: "solution-structure.svg"
            },
            {
                title: "UI/UX Development",
                description: "Our team designs interactive, engaging, and conversion-ready UI/UX.",
                icon: "s3.svg"
            },
            {
                title: "App Development",
                description: " We build responsive and scalable apps optimized for user performance.",
                icon: "app-development.svg"
            },
            {
                title: "Product Integration",
                description: "We integrate third-party tools and APIs to boost app functionality.",
                icon: "product-integration.svg"
            },
            {
                title: "Support & updates",
                description: "We ensure timely support and long-term success with updates and app care planning.",
                icon: "s5.svg"
            }
        ]
    }

    return (
        <>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <Subservices subservicesTitles={subservicesTitles} />
            <AppComparison compareHeader={compareHeader} diff1={diff1} diff2={diff2} />
            <ProcessSection processSection={processSection} />
            <CaseStudies />
            <Industries />
            <ClientSpeak />
            <GetQuote /> 
            <Contect />
            <Footer />
        </>
    )
}

export default MobileApp